import Axios from 'axios'

export const axios = Axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'https://air.onwardfree.com',
  withCredentials: true,
})

export const common = {
  paypal: { clientId: import.meta.env.VITE_PAYPAL_KEY },
  stripe: { clientId: import.meta.env.VITE_STRIPE_KEY }
}

export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms))

const retries = async (interval: number, handler: () => Promise<boolean>) => {
  while (! await handler()) {
    await sleep(interval)
  }
}

/**
 * Auto replace stripe public key per domain
 */
retries(5000, async () => {
  return axios.get<{ stripe?: string, paypal?: string }>('/public/payment/key')
    .then(res => res.data)
    .then(({ stripe, paypal }) => {
      stripe && (common.stripe.clientId = stripe)
      paypal && (common.paypal.clientId = paypal)

      return true
    })
    .catch(() => false)
    .finally(() => console.info('[WP Search] Selected public stripe key fetched'))
})

